import React, { useEffect } from "react";
import Input from "Components/UI/Input";
import { useFormContext, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { Select } from "antd";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const boolStatus2 = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const dataFieldOptions = [
  {
    label: "NRIC Number",
    value: "nricNumber",
  },
  {
    value: "photoIdBarcode",
    label: "Photo Id Barcode",
  },
  {
    value: "issuedDate",
    label: "Issued Date",
  },
  {
    value: "sector",
    label: "Sector",
  },
  {
    value: "dateOfApplication",
    label: "Date Of Application",
  },
  {
    value: "idExpiryDate",
    label: "ID Expiry Date",
  },
  {
    value: "sPassNumber",
    label: "S Pass Number",
  },
  {
    value: "workPermitNumber",
    label: "Work Permit Number",
  },
  {
    value: "workPermitRenewalDate",
    label: "Work Permit Renewal Date",
  },
  {
    value: "levyTypes",
    label: "Levy Types",
  },
  {
    value: "levyAmountTypes",
    label: "Levy Amount Types",
  },
  {
    value: "levyAmount",
    label: "Levy Amount",
  },
  {
    value: "pcpExpiryDate",
    label: "PCP Expiry Date",
  },
  {
    value: "pcpClinic",
    label: "PCP Clinic",
  },
  {
    value: "typeOfVisa",
    label: "Type Of Visa",
  },
  {
    value: "purpose",
    label: "Purpose",
  },
  {
    value: "remarks",
    label: "Remarks",
  },
  {
    value: "sgPassFrontImage",
    label: "SG Pass Front Image",
  },
  {
    value: "sgPassBackImage",
    label: "SG Pass Back Image",
  },
];

const PassTypeModal = ({ mode = "I", onSubmit, show = false, handleClose }) => {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Pass Type" : "Edit Pass Type"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              <Input
                name="passName"
                label="Pass Name"
                placeholder="Pass Name"
                className={`form-control ${
                  errors.passName ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Pass Name is requried"
              />
            </div>

            <div className="mb-3">
              <Input
                name="haveSkillUnSkillOption"
                type="commonSelect"
                placeholder="Have Skilled ?"
                className={`form-control ${
                  errors.haveSkillUnSkillOption ? "is-invalid" : ""
                }`}
                label="Have Skilled ?"
                labelClassName="form-label"
                optionData={boolStatus2}
                required={true}
                requiredMessage="Have Skilled is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("haveSkillUnSkillOption", selectedOption);
                  trigger("haveSkillUnSkillOption");
                }}
                defaultValue={watch("haveSkillUnSkillOption")}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>

            <div className="mb-3">
              <Input
                name="isActive"
                type="commonSelect"
                placeholder="Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Status"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Status is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue(
                    "isActive",
                    selectedOption ? selectedOption.value : null
                  );
                  trigger("isActive");
                }}
                getPopupContainer={(trigger) => trigger.parentNode}
                defaultValue={watch("isActive")}
              />
            </div>

            <div className="mb-3">
              <div className="form-floating">
                <Controller
                  name="dataFields"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <Select
                      {...field}
                      mode="multiple"
                      placeholder="Select Data Fields"
                      className="form-control"
                      options={dataFieldOptions}
                      onChange={(selectedOptions) => {
                        setValue("dataFields", selectedOptions);
                        trigger("dataFields");
                      }}
                      style={{ width: "100%", height: "auto" }}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                    />
                  )}
                />
                <label className="form-label">
                  Data Fields<span className="asterisk">*</span>
                </label>
                {errors.dataFields && (
                  <div className="invalid-feedback">
                    {errors.dataFields?.message || "Invalid input"}
                  </div>
                )}
              </div>
              {/* <Input
                name="isActive"
                type="commonSelect"
                placeholder=""
                className={`form-control ${errors.isActive ? "is-invalid" : ""}`}
                label="Data Fields"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Status is required"
                // onChange={(selectedOption) => {
                //   console.log(selectedOption);
                //   setValue(
                //     "dataFields",
                //     selectedOption ? selectedOption
                //   );
                //   trigger("dataFields");
                // }}
                defaultValue={watch("dataFields")}
              /> */}
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

PassTypeModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default PassTypeModal;
